// Original Testimonials code commented out as requested
/*
import { motion } from "framer-motion";
import aryanImg from "@/assets/image/Aryan.png";

const testimonialsData = [
  {
    name: "Aryan Rajvanshi",
    role: "TPA fellow, Batch of 2023",
    school: "Anand Niketan Satellite International School",
    quote: "I would like to express my gratitude to The Purpose Academy for granting me the incredible opportunity to pitch and present my project at UC Berkeley. During the program, I've had the privilege of learning essential soft skills and hard skills, including pitching techniques, business model planning, and project sustainability strategies.",
    image: aryanImg,
  }
];

export default function Testimonials() {
  return (
    <section className="bg-white py-24 relative overflow-hidden">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <div className="text-center mb-20">
          <h2 className="text-4xl font-extrabold text-[#7A3E54] uppercase tracking-wide">
            Testimonials
          </h2>
        </div>

        <div className="flex flex-wrap justify-center gap-8 relative">
          <div className="hidden lg:flex absolute -left-12 top-1/2 -translate-y-1/2 text-navy">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 text-slate-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </div>

          {testimonialsData.map((item, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
              className="relative mt-8 w-full max-w-md"
            >
              <div className="h-full rounded-[2rem] border-[3px] border-transparent bg-white shadow-lg relative p-8 pt-16 flex flex-col text-center"
                style={{
                  background: "linear-gradient(white, white) padding-box, linear-gradient(to bottom right, #5A3668, #A35064) border-box"
                }}>
                
                <div className="absolute -top-12 left-1/2 -translate-x-1/2 w-24 h-24 rounded-full overflow-hidden border-4 border-white shadow-md">
                  <img src={item.image} alt={item.name} className="w-full h-full object-cover" />
                </div>

                <h3 className="text-xl font-bold text-[#A35064] mb-1">{item.name}</h3>
                <p className="text-xs font-medium text-slate-600 mb-1">{item.role}</p>
                <p className="text-sm font-semibold text-navy mb-6 min-h-[40px]">{item.school}</p>
                <p className="text-sm leading-relaxed text-slate-700 italic flex-grow">
                  "{item.quote}"
                </p>
              </div>
            </motion.div>
          ))}

          <div className="hidden lg:flex absolute -right-12 top-1/2 -translate-y-1/2 text-navy">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 text-slate-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </div>
        </div>
      </div>
    </section>
  );
}
*/

import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import aryanImg from "@/assets/image/Aryan.png";
import satvikImg from "@/assets/image/Satvik.png";
import rayanImg from "@/assets/image/Rayan.jpeg";

interface TestimonialItem {
  name: string;
  school: string;
  projectTitle: string;
  description: string;
  image: string;
  gradient: string;
  icon: React.ReactNode;
  type: "single" | "bullets";
  accentColor?: string;
  title?: string;
  bullets?: React.ReactNode[];
}

const CompassIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" />
    <polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76" fill="currentColor" fillOpacity="0.2" />
  </svg>
);

// const SignalIcon = () => (
//   <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
//     <path d="M5 12.55a11 11 0 0 1 14.08 0" />
//     <path d="M1.42 9a16 16 0 0 1 21.16 0" />
//     <path d="M8.58 16.14a6 6 0 0 1 6.84 0" />
//     <circle cx="12" cy="19" r="1" fill="currentColor" />
//   </svg>
// );

// const LinkIcon = () => (
//   <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
//     <path d="M15 7h3a5 5 0 0 1 5 5 5 5 0 0 1-5 5h-3m-6 0H6a5 5 0 0 1-5-5 5 5 0 0 1 5-5h3" />
//     <line x1="8" y1="12" x2="16" y2="12" />
//   </svg>
// );

const testimonialsData: TestimonialItem[] = [
  {
    name: "Aryan Rajvanshi",
    school: "Anand Niketan Satellite International School, Ahmedabad",
    projectTitle: "Project Mechacrop",
    description: "With the purpose of helping farmers recover 30% of the output lost every year to diseases, Aryan Rajvanshi founded project MechaCrop. Using drone technology and machine learning, Aryan aimed to successfully identify and eradicate harmful diseases that plague Indian farms, thereby helping farmers regain control of their cultivation.",
    image: aryanImg,
    gradient: "linear-gradient(135deg, #7A2E46, #4C1C2D)", // Rose/Magenta-Burgundy
    icon: <CompassIcon />,
    type: "single"
  },
  {
    name: "Satvik",
    school: "Singapore International School",
    projectTitle: "FaslCast",
    description: "FaslCast is a data-driven agricultural advisory system designed to help small farmers make smarter selling decisions. By combining government mandi price data with machine learning forecasts, FaslCast provides simple, actionable guidance—reducing income loss caused by poor market timing and lack of information.",
    image: satvikImg,
    gradient: "linear-gradient(135deg, #0EA5E9, #0D9488)", // Teal/Cyan
    icon: <CompassIcon />,
    type: "single",
    // accentColor: "#0D9488",
    // title: "Aims & Projected Impact",
    // bullets: [
    //   <>Use Agmarknet data from <strong>3,000+ mandis</strong> to train forecasting models, predicting prices <strong>1–4 weeks</strong> ahead.</>,
    //   <>Deliver simple advisories: <strong>"Sell now"</strong>, <strong>"Hold"</strong>, <strong>"Sell at a different mandi"</strong>.</>,
    //   <>Ensure accessibility using <strong>SMS (Marathi/Hindi)</strong>, <strong>WhatsApp voice notes</strong>, and <strong>FPO-led communication</strong> for non-phone users.</>,
    //   <>Pilot FaslCast in <strong>5 Maharashtra districts</strong> for tomato, onion, soybean.</>,
    //   <>Onboard <strong>500+ farmers</strong> through partnerships with <strong>Farmer Producer Organisations (FPOs)</strong> and agricultural extension officers.</>,
    //   <>Improve farmer incomes by <strong>10–15%</strong> by reducing price uncertainty and improving decision-making.</>
    // ]
  },
  {
    name: "Rayan",
    school: "The International School, Bangalore (Grade 11)",
    projectTitle: "Project AgriBridge",
    description: "AgriBridge is an initiative focused on connecting middle-income farmers in Uttar Pradesh to local markets and government schemes to support sustainable income growth.",
    image: rayanImg,
    gradient: "linear-gradient(135deg, #115E59, #1E293B)", // Dark Green/Teal
    icon: <CompassIcon />,
    type: "single",
    // accentColor: "#115E59",
    // title: "Plan of Action",
    // bullets: [
    //   <><strong>Increase income</strong> for middle-income (income per month is less than <strong>10,000 INR</strong>) farmers by <strong>20%</strong>.</>,
    //   <><strong>Impact 40 farmers</strong> in Uttar Pradesh in the <strong>next 3-4 months</strong>.</>,
    //   <>Connect each of these farmers to at least <strong>1 local scheme</strong> and <strong>1 market</strong>.</>,
    //   <>Create a <strong>mobile application</strong> with <strong>local language support</strong> to help farmers connect to markets and schemes.</>
    // ]
  }
];

export default function Testimonials() {
  const [activeIndex, setActiveIndex] = useState(0);

  const handlePrev = () => {
    setActiveIndex((prev) => (prev === 0 ? testimonialsData.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setActiveIndex((prev) => (prev === testimonialsData.length - 1 ? 0 : prev + 1));
  };

  const current = testimonialsData[activeIndex];
  const isSingle = current.type === "single";

  return (
    <section className="bg-white py-24 relative overflow-hidden">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-sm font-bold text-slate-400 uppercase tracking-widest block mb-2">
            The Purpose Academy
          </span>
          <h2 className="text-4xl font-extrabold text-[#7A3E54] tracking-tight">
            Driving Impact
          </h2>
        </div>

        <div className={`relative w-full mx-auto px-4 lg:px-0 transition-all duration-300 ${isSingle ? "max-w-xl" : "max-w-5xl"}`}>
          <div className={`${isSingle ? "min-h-[500px]" : "min-h-[600px] lg:min-h-[500px]"} flex`}>
            <AnimatePresence mode="wait">
              <motion.div
                key={activeIndex}
                initial={{ opacity: 0, scale: 0.95 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.95 }}
                transition={{ duration: 0.3 }}
                className="flex flex-col lg:flex-row w-full rounded-[2rem] shadow-2xl overflow-hidden border-[3px] border-slate-100/50 bg-white"
              >
                {/* Left Panel - Student Profile & Project Description */}
                <div
                  className={`relative flex flex-col justify-between text-white p-8 lg:p-12 ${
                    isSingle ? "w-full text-center items-center" : "w-full lg:w-[45%] text-left"
                  }`}
                  style={{ background: current.gradient }}
                >
                  {/* Decorative radar background */}
                  <div className="absolute top-10 left-1/2 -translate-x-1/2 w-48 h-48 opacity-10 pointer-events-none select-none">
                    <svg viewBox="0 0 100 100" className="w-full h-full animate-[spin_60s_linear_infinite] text-white">
                      <circle cx="50" cy="50" r="45" stroke="currentColor" strokeWidth="0.5" strokeDasharray="2 2" fill="none" />
                      <circle cx="50" cy="50" r="38" stroke="currentColor" strokeWidth="0.5" strokeDasharray="1 4" fill="none" />
                      {[...Array(12)].map((_, i) => (
                        <line
                          key={i}
                          x1="50"
                          y1="5"
                          x2="50"
                          y2="10"
                          stroke="currentColor"
                          strokeWidth="1"
                          transform={`rotate(${i * 30} 50 50)`}
                        />
                      ))}
                    </svg>
                  </div>

                  <div className={`relative z-10 flex flex-col ${isSingle ? "items-center" : "items-center lg:items-start"}`}>
                    {/* Circular profile picture inside panel */}
                    <div className="w-28 h-28 rounded-full overflow-hidden border-4 border-white shadow-xl mb-6">
                      <img src={current.image} alt={current.name} className="w-full h-full object-cover" />
                    </div>

                    <h3 className="text-2xl font-bold">{current.name}</h3>
                    <p className={`text-sm text-white/80 font-medium mt-1 leading-snug ${isSingle ? "text-center" : "text-center lg:text-left"}`}>
                      {current.school}
                    </p>

                    <div className="w-16 h-[2px] bg-white/20 my-6" />

                    <div className={`flex items-center gap-2 mb-4 ${isSingle ? "justify-center" : "justify-center lg:justify-start"}`}>
                      <span className="p-1 bg-white/10 rounded-lg">{current.icon}</span>
                      <h4 className="text-lg font-bold tracking-wide uppercase">{current.projectTitle}</h4>
                    </div>

                    <p className={`text-sm leading-relaxed text-white/90 max-w-[420px] ${isSingle ? "text-center" : "text-center lg:text-left"}`}>
                      {current.description}
                    </p>
                  </div>

                  {/* Navigation dots at the bottom of the panel */}
                  <div className={`flex gap-2.5 mt-8 relative z-10 ${isSingle ? "justify-center" : "justify-center lg:justify-start"}`}>
                    {testimonialsData.map((_, idx) => (
                      <button
                        key={idx}
                        onClick={() => setActiveIndex(idx)}
                        className={`w-2.5 h-2.5 rounded-full transition-all duration-300 ${
                          activeIndex === idx ? "bg-white scale-125 shadow-md" : "bg-white/30 hover:bg-white/50"
                        }`}
                        aria-label={`Go to slide ${idx + 1}`}
                      />
                    ))}
                  </div>
                </div>

                {/* Right Panel - Key Details (Only for split-card bullets type) */}
                {!isSingle && (
                  <div className="w-full lg:w-[55%] p-8 lg:p-12 flex flex-col justify-center bg-slate-50/50">
                    <div>
                      <h4 
                        className="text-lg font-bold mb-6 pb-2 border-b border-slate-200"
                        style={{ color: current.accentColor }}
                      >
                        {current.title}
                      </h4>
                      <ul className="space-y-4">
                        {current.bullets?.map((bullet, bIdx) => (
                          <li key={bIdx} className="flex items-start gap-3 text-sm text-slate-600 leading-relaxed">
                            <span 
                              className="flex-shrink-0 mt-0.5"
                              style={{ color: current.accentColor }}
                            >
                              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                              </svg>
                            </span>
                            <span>{bullet}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                )}
              </motion.div>
            </AnimatePresence>
          </div>

          {/* Left Arrow Button */}
          <button
            onClick={handlePrev}
            className="absolute -left-16 top-1/2 -translate-y-1/2 p-2.5 rounded-full hover:bg-slate-100 transition-colors text-slate-300 hover:text-[#7A3E54] hidden lg:block"
            aria-label="Previous slide"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>

          {/* Right Arrow Button */}
          <button
            onClick={handleNext}
            className="absolute -right-16 top-1/2 -translate-y-1/2 p-2.5 rounded-full hover:bg-slate-100 transition-colors text-slate-300 hover:text-[#7A3E54] hidden lg:block"
            aria-label="Next slide"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </button>
        </div>
      </div>
    </section>
  );
}


